import styled from 'styled-components';

import { config } from './../../config/config';
const { colorConfig } = config();

export const CalculatorSection = styled.div`
  .radio-container.column .radioButton { min-width: 115px; }
  @media (min-width: 640px) {
    .radio-container { display: flex;  }
    .radio-container.column { padding-bottom: 0px; padding: 0px; }
  }
  @media (max-width: 639px) {
    .radio-container .radioButton svg { margin-top: 13px !important; }
  }
  .radio-container { margin-bottom: -5px !important; }
  .radio-container .label { margin: 0px !important; }

  .title {
    color: white;
    background: ${colorConfig.main};
    padding: 15px 20px;
    padding: 0px;
    margin: 10px 0px;
    line-height: 56px;
    text-align: center;
    font-size: 16px;
    font-family: 'Ubuntu', arial;
    font-weight: bold;
    color: white;
    align-items: center;
    border-radius: 5px;
  }

  margin-bottom: 20px;

  .section-inner { background: #e9f2f9; flex: 1; padding: 10px 20px; }
  .section-row { display: flex; background: transparent; align-items: stretch; }
  .pad { padding: 2px 20px; display: flex; align-items: center; width: calc(100% - 40px); }
  .column { padding: 20px 0px; flex: 1; }
  .column-icon { background: #0a2f70; min-width: 64px; border-radius: 5px; margin-right: 10px; text-align: center; display: flex; align-items: center; justify-content: center; }

  .column-icon.clr1 { background: #0a2f70; min-width: 60px; margin-bottom: 10px; margin-right: 5px; padding: 5px 0px;}
  .column-icon.clr2 { background: #0e7c88; min-width: 60px; margin-bottom: 10px; margin-right: 5px; padding: 5px 0px;}
  .column-icon.clr3 { background: #51bba4; min-width: 60px; margin-bottom: 10px; margin-right: 5px; padding: 5px 0px;}

  .column-cell { background: #e9f2f9; padding: 8px 8px; margin-bottom: 10px; border-radius: 5px;}

  .column-gap { min-width: 32px; margin-right: 10px; }
  .small-column { padding: 20px; flex: 0; }
  .label { color: #707070; font-size: 16px; font-weight: 600; font-family: 'Ubuntu', arial; text-align: left; margin-top:10px; margin-bottom: 10px; }
  .pad .label { flex: 1; font-family: 'Ubuntu', arial;  }

  @media(max-width: 480px) {
    .pad { display: block; padding-right: 0px; width: auto; }
    .label { padding-top:10px; margin-bottom: 0px; }
    .pad .label { flex: none; width: auto; }
    .section-row .column {
      margin: 0px !important;
      padding: 10px 20px !important;
    }
    .ranger {
      margin-top: 20px;
      margin-bottom: 15px;
      left: 5% !important;
      width: 85% !important;
    }
  }

  @media(max-width: 800px) {
    .section-row { display: block; }
    .small-column, .column { padding-top: 10px; padding-bottom: 10px; }
  }
`;

export const Centered = styled.div`
  max-width: ${props => props.width || 800}px;
  margin: 0px auto;
  @media(max-width: 860px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const OneColumnLayout = styled.div`
  max-width: 1200px;
  margin: 20px auto;
  display: flex;

  .sidebar { margin-right: 20px; width: 400px; }
  .content { flex: 1; background: #e9f2f9; padding: 0px 20px; }

  @media(max-width: 1024px) {
    display: block;
    margin-left: 20px;
    margin-right: 20px;
    .sidebar { margin-right: 0px; width: 100%; }
  }

  .ranger { width: 150px;  }
  .label-choose {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 11px;
    text-align: left;
    font-weight: 400;
    color: #000;
  }

  @media(max-width: 480px) {
    .ranger {
      margin-top: 20px;
      margin-bottom: 15px;
      left: 5% !important;
      width: 85% !important;
    }
    .label-choose {
      font-size: 13px;
    }
  }

`;



// WEBPACK FOOTER //
// ./src/components/Calculators/Sections.js